// extracted by mini-css-extract-plugin
module.exports = {"singleFAQ":"singleFAQ_singleFAQ__3XY6T","faq":"singleFAQ_faq__11lxi"};